
import { Header } from '../models';
import { waitFor } from "vue-wait";
import { UserMenu, ChooseSalonDialog } from './Common/CommonComponents';
export default {
	props: {
		/**
		 * Options for integrated FixitNoHeader component
		 *
		 * required :
		 *  @param {apiUrl} apiUrl url endpoint for login
		 *
		 * optional :
		 *  @param {headerColors} headerColors  default ["#BFE5E8", "#EFDDD1"] ;
		 *  @param {height} height  default 70 ;
		 *  @param {elevation} elevation  default 3 ;
		 *  @param {items} items  default [] ;
		 *  @param {layout} layout  default 'chain' ;
		 *  @param {atTop} atTop  default false ;
		 * @see TheFixitNoHeader
		 */
		headerProps: {
			type: [Header, Object],
			default: function () {
				return new Header();
			},
		},
		/**
		 * Currently logged in user or empty object
		 * @see User
		 */
		activeUser: {
			type: Object,
			required: true,
		},

		fixitMenuValue: {
			type: Boolean,
			default: false,
		},

		fixitLoginDialog: {
			type: Boolean,
			default: false,
		},
		userMenu: {
			type: Boolean,
			default: false,
		},
		newRelease: {
			type: Boolean,
			default: false,
		},
		useOldNavigation: {
			required: false,
			default: false,
			type: Boolean
		}
	},
	name: 'TheAppBar',
	components: {
		UserMenu,
		ChooseSalonDialog,
	},

	data: () => ({
		treatment: null,
		isMounted: false,
		internalMenuState: false, // Re-introduce this
	}),
	mounted() {
		this.isMounted = true;
		this.internalMenuState = this.fixitMenuValue; // Initialize internal state
	},
	computed: {
		activeTab() {
			// fixes slider position in case tabs weren't rendered
			if (this.$refs.tabs) this.$refs.tabs.callSlider();
			// if (this.$refs.tabs && this.headerProps.items.findIndex((x) => x.Link === this.$route?.path) != -1) this.$refs.tabs.change(this.headerProps.items.findIndex((x) => x.Link === this.$route?.path))
			return this.headerProps.items.findIndex((x) => x.Link === this.$route?.path);
		},
		useConstrastColors() {
			return this.headerProps.layout == 'chain' ? this.$store.getters['cmsConfigHomepage/primaryAndSecondaryAreEqual'] : false
		},
		home() {
			return this.$route?.path === '/';
		},
		user: {
			get() {
				return this.activeUser;
			},
			set(user) {
				// this.setUserMenuOffsetY(this.headerProps.height)
				this.loginDialog = false;
				// this.$emit("setUser", new User(user));
			},
		},
		loginDialog: {
			get() {
				return this.fixitLoginDialog;
			},
			set(value) {
				this.$emit('setLogin', value);
			},
		},
		userDialog: {
			get() {
				return this.userMenu;
			},
			set(value) {
				this.$emit('setUserMenu', value);
			},
		},
		isDraft() {
			return this.$store.getters['cmsConfigHomepage/isDraftMode']
		},
		isNoShowPayment() {
			return (this.$route.path.includes('/betaling') || this.$route.path.includes('/bekreftelse')) && (this.$route.path.includes('/ikke-mott') || this.$route.path.includes('/sen-kansellering'))
		},
		sites() {
			if (!(this.$router.currentRoute.path.includes('nettbutikk') || window.location.host.includes('profil.'))) {
				let selectedSalon = this.$store.getters['cart/getSelectedSalon']
				if (selectedSalon) {
					return this.headerProps.sites.filter(x => x.siteId === selectedSalon);
				} else {
					return this.headerProps.sites
				}
			} else return this.headerProps.sites
		}
	},
	methods: {
		toggleMenu() {
			this.internalMenuState = !this.internalMenuState;
			this.$emit('setFixitMenu', this.internalMenuState);
		},
		redirectToLogin() {
			const portalUrl = process.env.VUE_APP_FIXIT_NO_URL ?? this.$config.VUE_APP_FIXIT_NO_URL;
			if (portalUrl != window.location.origin) {
			
				this.$emit('open-login-dialog')
			}else
			{
			const url = process.env.VUE_APP_B2C_LOGIN_URL ?? this.$config.VUE_APP_B2C_LOGIN_URL;
			window.location.href = url + '?returnUrl=' + window.location.href;
			}

			  
		},
		navigationAction(nav) {
			this.$emit('close-profile')
			if (this.internalMenuState) {
				this.internalMenuState = false; // Ensure this is set to false
			}
			if (nav.Dialog) {
				this[nav.DialogVariable] = true;
			} else if (nav.isInternal) {
				this.$router.push(nav.Link);
			} else if (nav.Link && nav.OpenInNewWindow) {
				window.open(nav.Link);
			} else if (nav.Caption == 'Nettbutikk') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL || this.$config.PORTAL_URL}${nav.Link}`, `${this.$config.PORTAL_URL ? '_blank' : '_self'}`)
			} else if (nav.Link.includes('/bedrift')) {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Kjøp gavekort') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Steder') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Behandlinger') {
				this.headerProps.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self') : this.$router.push('/behandlinger')
			} else if (nav.Caption == 'Min side') {
				this.$emit('set-profile', true)
			}
			else {
				this.$router.push(nav.Link)
			}
			// this.$nuxt.$loading.finish();
		},
		openLoginDialog() {
			this.$emit('open-login-dialog');
		},
		logout() {
			this.$emit('logout');
		},
		/**
		 * Set top position for user menu dropdown based on the header's height.
		 * Header height is set in the headerProps.height, and is being watched.
		 */
		setUserMenuOffsetY(value) {
			if (document || typeof process != undefined) {
				var headermenu = document.getElementsByClassName('fixit-no__user-menu').length ? document.getElementsByClassName('fixit-no__user-menu') : document.getElementsByClassName('fixit-no__user-menu__mobile')
				for(var i = 0; i < headermenu.length; i++)
				{
					headermenu[i].style.top = `${value}px`;
					headermenu[i].style.maxHeight = `calc(100vh - ${value}px)`;
					if (value < 120) {
						headermenu[i].style.borderTop = `none`;
					} else {
						headermenu[i].style.borderTop = `3px solid var(--v-primary-base)`;
					}
				}
			}
		},
		waitFor,
		resetInternalMenuState() {
			this.internalMenuState = false;
			},
	},
	watch:{
		$route (to, from){
			if (to.params.treatment) {
				waitFor(`fetch treatment`, async function () {
					this.treatment = await this.$store.dispatch("treatments/fetchTreatment", to.params.id)
				}).apply(this);
			}
		},
		"headerProps.height": {
			handler(val) {
				this.setUserMenuOffsetY(val)
			},
			deep: true,
			immediate: true
		},
		fixitMenuValue(newValue) { // Re-introduce watcher
			this.internalMenuState = newValue;
		},
	}
};
